import React, { useEffect, useState } from 'react'
import Logo2 from '../image/Logo2.png'
import '../css/NavBar.css'

const NavBar = () => {

    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {

        const handleScroll = () => {
            setScrolled(window.scrollY > 40)
        }

        window.addEventListener("scroll", handleScroll)

        return () => window.removeEventListener("scroll", handleScroll)

    }, [])

    return (

        <header className={`navbar-custom ${scrolled ? "scrolled" : ""}`}>

            <div className="container navbar-container">

                {/* LOGO */}
                <a href="#" className="navbar-brand-custom">

                    <img
                        src={Logo2}
                        alt="Logo"
                        className="logo-navbar"
                    />

                    <div className="brand-text">

                        <h4>
                            ICS
                        </h4>

                        <span>
                            Ingeniería Colombiana de Sistemas
                        </span>

                    </div>

                </a>

                {/* LINKS */}
                <nav className="navbar-links">

                    <a href="#" className="active">
                        Inicio
                    </a>

                    <a href="#">
                        Servicios
                    </a>

                    <a href="#">
                        Portafolio
                    </a>

                    <a href="#">
                        Soluciones
                    </a>

                    <a href="#">
                        Contacto
                    </a>

                </nav>

                {/* ACTIONS */}
                <div className="navbar-actions">

                    <button className="btn-navbar-secondary">

                        <i className="fa-solid fa-headset"></i>

                        Soporte

                    </button>

                    <button className="btn-navbar-primary">

                        Solicitar asesoría

                    </button>

                </div>

                {/* MOBILE BUTTON */}
                <button
                    className="navbar-mobile-btn"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbar"
                >

                    <i className="fa-solid fa-bars-staggered"></i>

                </button>

            </div>

            {/* MOBILE MENU */}
            <div
                className="offcanvas offcanvas-end navbar-offcanvas"
                tabIndex="-1"
                id="offcanvasNavbar"
            >

                <div className="offcanvas-header">

                    <div className="mobile-logo">

                        <img
                            src={Logo2}
                            alt="Logo"
                        />

                        <div>

                            <h5>
                                ICS
                            </h5>

                            <span>
                                Tecnología Empresarial
                            </span>

                        </div>

                    </div>

                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        data-bs-dismiss="offcanvas"
                    ></button>

                </div>

                <div className="offcanvas-body">

                    <div className="mobile-links">

                        <a href="#">
                            Inicio
                        </a>

                        <a href="#">
                            Servicios
                        </a>

                        <a href="#">
                            Portafolio
                        </a>

                        <a href="#">
                            Soluciones
                        </a>

                        <a href="#">
                            Contacto
                        </a>

                    </div>

                    <div className="mobile-actions">

                        <button className="btn-navbar-secondary w-100">

                            <i className="fa-solid fa-headset"></i>

                            Soporte

                        </button>

                        <button className="btn-navbar-primary w-100">

                            Solicitar asesoría

                        </button>

                    </div>

                </div>

            </div>

        </header>

    )
}

export default NavBar